// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tab-content .tab-pane[data-v-37a9027a] {\n  padding: 0 !important;\n}\n.tab-content[data-v-37a9027a] {\n  border: 0 !important;\n}\n.card[data-v-37a9027a] {\n  border: 0;\n  padding: 0;\n  margin-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
